<template>
  <div>
    <div
      v-ripple
      class="group p-3 flex items-center text-surface-600 dark:text-surface-400 hover:bg-surface-100 dark:hover:bg-surface-700 duration-200 transition-colors cursor-pointer rounded-md"
      @click.stop="on_toggle"
    >
      <div class="mr-2">
        <span :class="['chevron', { rotated: is_open }]">
          <FontAwesomeIcon
            class="has-text-grey"
            icon="chevron-right"
          />
        </span>
      </div>
      <span class="transition-colors group-hover:text-surface-900 dark:group-hover:text-surface-50">
        {{ title }}
      </span>
    </div>
    <transition name="fade-slide">
      <ul
        v-if="is_open"
        class="list-none px-2 py-1 m-0 rounded dark:bg-surface-800 relative"
      >
        <div
          v-if="is_fetching"
          class="flex flex-col gap-2"
        >
          <Skeleton
            borderRadius="16px"
            class="mb-2 mx-4"
            width="18rem"
          />
          <Skeleton
            borderRadius="16px"
            class="mb-2 mx-4"
            width="15rem"
          />
        </div>
        <li
          v-for="project in projects"
          v-else-if="projects.length > 0"
          :key="project.id"
        >
          <SidebarProjectItem
            v-bind="item_props"
            :project="project"
            :toggled_project_id="toggled_project_id"
            @closeProjectSidebar="emit('closeProjectSidebar')"
            @follow="emit('follow', $event)"
            @toggleProjectId="emit('toggleProjectId', $event)"
            @unfollow="emit('unfollow', $event)"
          />
        </li>
        <div
          v-else
          class="text-surface-500 p-2 mx-5 italic"
        >
          {{ $t('project.labels.noProjects') }}
        </div>
      </ul>
    </transition>
  </div>
</template>

<script setup>
import SidebarProjectItem from './SidebarProjectItem.vue';

// Define props
defineProps({
  title: { type: String, default: '' },
  is_open: { type: Boolean, default: false },
  on_toggle: { type: Function, default: () => {} },
  projects: { type: Array, default: () => [] },
  item_props: { type: Object, default: () => ({}) },
  is_fetching: { type: Boolean, default: false },
  toggled_project_id: { type: String, default: null },
});

// Define emits
const emit = defineEmits(['closeProjectSidebar', 'follow', 'toggleProjectId', 'unfollow']);

// on_toggle is passed as a prop and used directly in the template
</script>

<style scoped>
.chevron {
  display: inline-block;
  transition: transform 0.2s;
}
.chevron.rotated {
  transform: rotate(90deg);
}

/* Fade and slide transition */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition:
    opacity 0.18s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.18s cubic-bezier(0.4, 0, 0.2, 1);
}
.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
.fade-slide-enter-to,
.fade-slide-leave-from {
  opacity: 1;
  transform: translateY(0);
}
</style>
